import { useMutation, useQueryClient } from 'react-query';
import { API } from '../../../utils/ApiClient';
import { useSnackbar } from 'notistack';

function useDeleteTask() {
    const { enqueueSnackbar } = useSnackbar();
    const queryClient = useQueryClient();
    return useMutation<unknown, unknown, { id?: string }>({
        mutationFn: ({ id }) => API.delete(`/tasks/${id}`),
        onSuccess() {
            enqueueSnackbar('Deletion successful');
            queryClient.invalidateQueries('tasks');
        },
    });
}

export default useDeleteTask;
